import SITEPLUS_GET_WEBSITE_DETAILS from '@/graphql/GET_SITEPLUS_WEBSITE_DETAILS.gql'
import SITEPLUS_GET_WEBSITE_SSO_URL from '@/graphql/GET_SITEPLUS_WEBSITE_SSO_URL.gql'
import ACTIVATE_SITEPLUS_SHOP from '@/graphql/ACTIVATE_SITEPLUS_SHOP.gql'
import SET_SITEPLUS_DOMAIN_NAME from '@/graphql/SET_SITEPLUS_DOMAIN_NAME.gql'

import { mapState } from 'vuex'

const generatedSiteplusUrlMixin = {
  computed: {
    ...mapState(['services'])
  },
  data () {
    return {
      errors: null,
      domainName: '',
      servicesList: []
    }
  },
  apollo: {
    siteplusWebsiteDetails: {
      skip () {
        return Boolean(!this.services.sitepluswebsite)
      },
      query: SITEPLUS_GET_WEBSITE_DETAILS,
      variables () {
        return { sitePlusWebsiteId: this.services.sitepluswebsite }
      },
      update (data) {
        return data.sitePlusWebsiteDetailsGet
      },
      error (error) {
        this.errors = JSON.stringify(error.message)
        return null
      },
      fetchPolicy: 'network-only',
      pollInterval: 30000
    }
  },
  methods: {
    async goToSiteplusGeneratedLink (linkFn, evt) {
      let newtab, link
      if (evt) {
        // If we include an event, grab the innertext
        // of the target to display 'loading' text
        const innerText = evt.target.innerText
        evt.target.innerText = 'Loading...'
        try {
          link = await linkFn()
          newtab = window.open()
          newtab.location = link
        } catch (err) {
        } finally {
          evt.target.innerText = innerText
        }
      } else {
        // If no event is included, open a new tab
        // immediately. Better when from the sidebar
        newtab = window.open()
        link = await linkFn()
        newtab.location = link
      }
    },

    async getSiteplusWebsiteEditLink () {
      try {
        const { data } = await this.$apollo.query({
          query: SITEPLUS_GET_WEBSITE_SSO_URL,
          variables: {
            sitePlusWebsiteId: this.services.sitepluswebsite
          },
          fetchPolicy: 'network-only'
        })
        return data.sitePlusWebsiteSsoUrlGet
      } catch (err) {
        return err
      }
    },

    async getSiteplusWebsiteAnalitycsLink () {
      try {
        const { data } = await this.$apollo.query({
          query: SITEPLUS_GET_WEBSITE_SSO_URL,
          variables: {
            sitePlusWebsiteId: this.services.sitepluswebsite,
            ip: null,
            countryCode: null,
            userAgent: null,
            destination: 'Analytics'
          },
          fetchPolicy: 'network-only'
        })
        return data.sitePlusWebsiteSsoUrlGet
      } catch (err) {
        return err
      }
    },

    // ASSIGN SITEPLUS DOMAIN NAME
    async assignSiteplusDomainName (domainName=null) {

      if (this.services.sitepluswebsite) {
        if (domainName != null) {
          var domain = domainName;
        } else {
          var domain = this.domainName;
        }

        try {
          const { data } = await this.$apollo.mutate({
            mutation: SET_SITEPLUS_DOMAIN_NAME,
            variables: {
              sitePlusWebsiteId: this.services.sitepluswebsite,
              domainName: domain
            }
          })
          if (data.sitePlusWebsiteAssignDomainName) {
            return data.sitePlusWebsiteAssignDomainName
          }
          return false
        } catch (err) {
          console.error(err)
          return false
        }
      }
      return false
    },

    // ACTIVATE SHOP
    async activateShop () {
      if (this.services.sitepluswebsite) {
        try {
          const { data } = await this.$apollo.mutate({
            mutation: ACTIVATE_SITEPLUS_SHOP,
            variables: {
              sitePlusWebsiteId: this.services.sitepluswebsite
            }
          })

          if (data.sitePlusWebsiteEnableOptionalPlan) {
            return data.sitePlusWebsiteEnableOptionalPlan
          }
          return false
        } catch (err) {
          return false
        }
      }
      return false
    }

  }
}

export default generatedSiteplusUrlMixin
